var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"whiteboard",staticClass:"whiteboard",class:_vm.currentToolName,style:({
    'pointer-events': _vm.status ? 'auto' : 'none',
  })},[_c('canvas',{ref:"canvas",on:{"load":_vm.onload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }